import gql from "graphql-tag";

export const GET_MAIL_SETS = gql`
	query MailSets($before: String, $after: String, $first: Int, $last: Int, $where: MailSetFilterInput, $order: [MailSetSortInput!]) {
		mailSets (
			before: $before
			after: $after
			first: $first
			last: $last,
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				description
				dateTimeStamp
				scheduledDateTime
				status
				failedMailCount
				totalMailCount
				deliveredMailCount
				template
				metaData {
					fileName
				}
			}
		}
	}
`;
